import { Link } from 'react-router-dom';

const ENTRIES = [
  {
    type: 'movie',
    title: '电影',
    desc: '最新大片 · 经典佳作',
    count: '2,800+ 部',
    icon: 'ri-film-line',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20and%20clapperboard%20on%20a%20deep%20navy%20studio%20background%20with%20warm%20spotlight%2C%20dramatic%20moody%20lighting%2C%20elegant%20minimal%20composition&width=800&height=600&seq=yaojing-entry-movie&orientation=landscape',
  },
  {
    type: 'tv',
    title: '电视剧',
    desc: '口碑热剧 · 高分剧集',
    count: '1,600+ 部',
    icon: 'ri-tv-2-line',
    image: 'https://readdy.ai/api/search-image?query=Retro%20television%20set%20glowing%20in%20a%20dark%20room%20with%20warm%20ambient%20light%2C%20deep%20blue%20shadows%2C%20cozy%20cinematic%20atmosphere%2C%20minimal%20elegant%20composition&width=800&height=600&seq=yaojing-entry-tv&orientation=landscape',
  },
  {
    type: 'variety',
    title: '综艺',
    desc: '人气综艺 · 新季上线',
    count: '900+ 档',
    icon: 'ri-mic-line',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20stage%20spotlights%20and%20confetti%20on%20a%20deep%20navy%20background%2C%20playful%20energetic%20variety%20show%20vibe%2C%20glowing%20warm%20accents%2C%20minimal%20composition&width=800&height=600&seq=yaojing-entry-variety&orientation=landscape',
  },
];

export default function CategoryEntries() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14">
      <div className="flex items-end justify-between mb-6">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-extrabold text-foreground-950">分类快捷入口</h2>
          <p className="mt-1 text-sm text-foreground-600">按类别快速找到你想看的内容</p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {ENTRIES.map((entry) => (
          <Link
            key={entry.type}
            to={`/category/${entry.type}`}
            className="group relative h-52 rounded-lg overflow-hidden border border-background-200"
          >
            <img
              src={entry.image}
              alt={`${entry.title}分类入口`}
              title={`${entry.title}频道 - 妖精视频`}
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/40 to-transparent"></div>
            <div className="relative z-10 h-full p-5 flex flex-col justify-end">
              <span className="w-11 h-11 rounded-lg bg-accent-500 flex items-center justify-center mb-3">
                <i className={`${entry.icon} text-2xl text-background-50`}></i>
              </span>
              <h3 className="font-heading text-2xl font-extrabold text-background-50">{entry.title}</h3>
              <p className="mt-1 text-sm text-background-100/85">{entry.desc}</p>
              <div className="mt-2 flex items-center justify-between">
                <span className="text-xs text-accent-300 font-medium">{entry.count}</span>
                <span className="inline-flex items-center gap-1 text-xs font-semibold text-background-50">
                  进入频道
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}